import React from 'react';
import { HelpOutline } from '@mui/icons-material';
import '../../ucat-styles.css';

interface UcatModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  showConfirmButton?: boolean;
  showCancelButton?: boolean;
  width?: string;
}

export const UcatModal: React.FC<UcatModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Yes",
  cancelText = "No",
  showConfirmButton = true,
  showCancelButton = true,
  width = "max-w-md"
}) => {
  if (!isOpen) return null;

  return (
    <div className="ucat-module fixed inset-0 z-[10000] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
      <div
        className={`bg-white shadow-2xl w-full ${width} max-h-[90vh] flex flex-col border border-gray-400`}
      >
        {/* Header */}
        <div
          className="flex items-center justify-between py-1 px-4 text-white border-b"
          style={{ backgroundColor: "#005a9c", borderBottomColor: "#003B70" }}
        >
          <h3 className="font-bold text-[16px] flex items-center gap-2">
            {title}
          </h3>
        </div>

        {/* Content */}
        <div
          className="p-4 overflow-y-auto flex-1"
          style={{ backgroundColor: "#006DAA", minHeight: "120px" }}
        >
          <div className="flex items-start gap-3">
            <HelpOutline
              sx={{
                color: "white",
                fontSize: 28,
                marginTop: "2px",
              }}
            />
            <p className="text-[14px] text-white leading-relaxed">
              {message}
            </p>
          </div>

          {/* Buttons */}
          <div className="flex justify-center gap-4 mt-6">
            {showConfirmButton && onConfirm && (
              <button
                onClick={onConfirm}
                className="px-6 py-2 bg-[#005a9c] text-white font-semibold text-[14px] hover:text-yellow-400 transition-colors border border-white"
              >
                {confirmText}
              </button>
            )}
            {showCancelButton && (
              <button
                onClick={onClose}
                className="px-6 py-2 bg-[#005a9c] text-white font-semibold text-[14px] hover:text-yellow-400 transition-colors border border-white"
              >
                {cancelText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
